import React from 'react';
import { MapPinIcon, FileTextIcon, Trash2Icon, ArrowUpIcon } from 'lucide-react';
import { previewCopy, type Bi, type CapabilityKey } from '../../../data/communicationsProof';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
function MapPreview() {
  return <div className="relative w-full h-full rounded-lg overflow-hidden bg-[#EEF1EE]" aria-hidden="true" data-id="element-2757" data-mp="kgxvsdmqludx">
      <svg viewBox="0 0 120 70" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full" data-id="element-2758" data-mp="y7t7rysj8rlq">
        <rect width="120" height="70" fill="#EEF1EE" data-id="element-2759" data-mp="t8q1kb0tgfc6" />
        <path d="M78 0 C 84 20, 110 30, 104 50 C 100 62, 112 66, 120 70 L120 0 Z" fill="#BCD7EF" data-id="element-2760" data-mp="186s4qk3xqysw" />
        <path d="M60 36 C 70 30, 82 44, 94 36" fill="none" stroke="#B9DDB8" strokeWidth="7" data-id="element-2761" data-mp="137pbdwxbih0r" />
        <g stroke="#FFFFFF" strokeWidth="1.6" data-id="element-2762" data-mp="39y5blepgrgrl">
          <line x1="0" y1="22" x2="120" y2="30" data-id="element-2763" data-mp="39yy9dq6g2vxl" />
          <line x1="0" y1="48" x2="120" y2="54" data-id="element-2764" data-mp="34z24zptu52hi" />
          <line x1="34" y1="0" x2="28" y2="70" data-id="element-2765" data-mp="350diwigzvqmc" />
          <line x1="66" y1="0" x2="62" y2="70" data-id="element-2766" data-mp="2gyf8f9mixaxt" />
        </g>
      </svg>
      <MapPinIcon className="absolute left-[36%] top-[22%] w-4 h-4 text-[#4F46E5] fill-[#EEEDFD]" data-id="element-2767" data-mp="2h09rsji5cuzs" />
      <MapPinIcon className="absolute left-[64%] top-[56%] w-4 h-4 text-[#4F46E5] fill-[#EEEDFD]" data-id="element-2768" data-mp="2l0a68458x66u" />
    </div>;
}
function NoticePreview({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="relative w-full h-full" aria-hidden="true" data-id="element-2769" data-mp="2urekt2r0ep15">
      <div className="absolute left-[18%] right-[6%] top-0 h-[70%] rounded-t-xl bg-[#1B1E3A]" data-id="element-2770" data-mp="2zppw7hwyd7lh" />
      <div className="absolute left-0 right-0 bottom-0 rounded-lg bg-white border border-[#EEEEF4] shadow-[0_8px_18px_-10px_rgba(20,20,60,0.45)] px-2 py-1.5" data-id="element-2771" data-mp="34nhv4vw0ltz6">
        <p className="flex items-center justify-between font-sans text-[7.5px] text-[#6B7180]" data-id="element-2772" data-mp="38ns3gf7a4wh7">
          <span className="flex items-center gap-1 font-semibold text-[#121212]" data-id="element-2773" data-mp="3dmlfe36x4ff9">
            <span className="w-2.5 h-2.5 rounded-sm bg-[#1B1E3A]" data-id="element-2774" data-mp="1edep63z75ljp" />
            {previewCopy.notifApp}
          </span>
          {pick(previewCopy.notifNow)}
        </p>
        <p className="font-sans text-[8px] font-semibold text-[#121212] mt-0.5" data-id="element-2775" data-mp="2mmlxkjaaoy3p">{pick(previewCopy.notifTitle)}</p>
        <p className="font-sans text-[7.5px] text-[#3A4050] leading-tight line-clamp-2" data-id="element-2776" data-mp="2hnsrhbxc89dk">{pick(previewCopy.notifBody)}</p>
      </div>
    </div>;
}
function RequestPreview({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="w-full h-full flex flex-col justify-between" aria-hidden="true" data-id="element-2777" data-mp="2qpa76t6u291q">
      <span className="self-end inline-flex items-center gap-1 rounded-md bg-[#4F46E5] px-2 py-1 font-sans text-[8px] font-medium text-white whitespace-nowrap" data-id="element-2778" data-mp="35ivjttvcouys">
        <FileTextIcon className="w-2.5 h-2.5" data-id="element-2779" data-mp="3ed04twnszc6e" />
        {pick(previewCopy.newRequest)}
      </span>
      <div className="rounded-lg border border-[#EEEEF4] bg-white px-2 py-1.5 flex items-center gap-2" data-id="element-2780" data-mp="3aawrf2hkpxih">
        <span className="w-6 h-6 rounded bg-[#5B6070] shrink-0" data-id="element-2781" data-mp="3oa4w2awi9xu2" />
        <span className="min-w-0 flex-1" data-id="element-2782" data-mp="3jbuyxur80n5t">
          <span className="block font-sans text-[8.5px] font-semibold text-[#121212] truncate" data-id="element-2783" data-mp="3jcw97x0ex5mh">{pick(previewCopy.requestTitle)}</span>
          <span className="flex items-center gap-1.5 font-sans text-[7.5px] text-[#6B7180]" data-id="element-2784" data-mp="6q5zyvczd464">
            {previewCopy.requestId}
            <span className="rounded bg-[#EAF7EE] px-1 text-[#1E8A45] whitespace-nowrap" data-id="element-2785" data-mp="3szpdop3y31pg">{pick(previewCopy.requestStatus)}</span>
          </span>
        </span>
      </div>
    </div>;
}
function CollectPreview({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="w-full h-full rounded-lg border border-[#EEEEF4] bg-white px-2.5 py-2 flex flex-col" aria-hidden="true" data-id="element-2786" data-mp="3k5ua3lih1jbx">
      <p className="flex items-start gap-1.5" data-id="element-2787" data-mp="3a8zbl2m77ixn">
        <Trash2Icon className="w-3.5 h-3.5 text-[#2563EB] shrink-0" data-id="element-2788" data-mp="3aaael07tkmnp" />
        <span className="min-w-0" data-id="element-2789" data-mp="3f7iyb58m8yr2">
          <span className="block font-sans text-[8.5px] font-semibold text-[#121212] leading-tight" data-id="element-2790" data-mp="3f8tyyw6rlqdy">{pick(previewCopy.collectTitle)}</span>
          <span className="block font-sans text-[7.5px] text-[#6B7180]" data-id="element-2791" data-mp="31aneqiuqnowr">{pick(previewCopy.collectDate)}</span>
        </span>
      </p>
      <p className="mt-auto flex justify-center gap-2.5" data-id="element-2792" data-mp="2y6xyoenplppc">
        {['#6D5DF6', '#2E86DE', '#22A04F'].map(c => <Trash2Icon key={c} className="w-3.5 h-3.5" style={{
        color: c
      }} data-id="element-2793" data-mp="2t8wh5y5xlyfz" />)}
      </p>
    </div>;
}
function AnalyticsPreview({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="w-full h-full rounded-lg border border-[#EEEEF4] bg-white px-2.5 py-2 flex flex-col" aria-hidden="true" data-id="element-2794" data-mp="2jijvu3qam18s">
      <p className="font-sans text-[8.5px] font-semibold text-[#121212]" data-id="element-2795" data-mp="2fhrojg0ze6f5">{pick(previewCopy.reach)}</p>
      <div className="mt-auto flex items-end justify-between gap-2" data-id="element-2796" data-mp="2afiwclvxn8e3">
        <span className="flex items-end gap-1 h-7" data-id="element-2797" data-mp="25j25hjxcmfxb">
          {[40, 58, 70, 88].map(h => <span key={h} className="w-2 rounded-sm bg-[#8B7FF7]" style={{
          height: `${h}%`
        }} data-id="element-2798" data-mp="20jplr81rxoyy" />)}
        </span>
        <span className="text-right" data-id="element-2799" data-mp="3q4778ksyv4z">
          <span className="block font-sans text-[11px] font-semibold text-[#121212]" data-id="element-2800" data-mp="3uwxjb7h4weoa">{pick(previewCopy.reachValue)}</span>
          <span className="inline-flex items-center gap-0.5 rounded bg-[#EAF7EE] px-1 font-sans text-[7.5px] text-[#1E8A45]" data-id="element-2801" data-mp="793brsh969gr">
            <ArrowUpIcon className="w-2 h-2" data-id="element-2802" data-mp="b8uaqjgxnvwd" />
            {pick(previewCopy.reachTrend)}
          </span>
        </span>
      </div>
    </div>;
}
export function CapabilityPreview({
  isFR,
  kind
}: P & {
  kind: CapabilityKey;
}) {
  switch (kind) {
    case 'map':
      return <MapPreview data-id="element-2803" data-mp="3kfljdljcqfwf" />;
    case 'notices':
      return <NoticePreview isFR={isFR} data-id="element-2804" data-mp="3kgwmrk8vxln0" />;
    case 'requests':
      return <RequestPreview isFR={isFR} data-id="element-2805" data-mp="3ofx4ezfmmi8f" />;
    case 'collect':
      return <CollectPreview isFR={isFR} data-id="element-2806" data-mp="3oii53l46us4l" />;
    default:
      return <AnalyticsPreview isFR={isFR} data-id="element-2807" data-mp="3tf0bepf62yj1" />;
  }
}